import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import loginValidation from './loginValidation';
import * as AuthActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

import { actions as idleActions } from '../redux-idle-monitor'

@translate(['common'])
@connect(
	state => ({ user: state.auth.user, loginError: state.auth.loginError }),
	dispatch => bindActionCreators(AuthActions, dispatch)
)
@reduxForm({
	form: 'loginForm',
	fields: ['username', 'password'],
	validate: loginValidation,
	destroyOnUnmount: true
})

export default class LoginForm extends Component {

	constructor(props) {
		super(props);
		this.state = { showPassword: false };
	}

	render() {
		const {
			fields: { username, password },
			formKey,
			handleSubmit,
			invalid,
			submitting,
			resetForm,
			values,
			loading,
			loginError,
			t,
			login
		} = this.props;

		const { user, logout, error } = this.props;

		const styles = require('containers/Login/Login.scss');

		if (loginError != false) {
			var errorAlert = (
				<div className="alert alert-danger" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"> </span> &nbsp;
					{loginError}
				</div>);
		} else {
			var errorAlert = ''; 
		}

		var labelClass = 'col-xs-3 control-label';
		var inputClass = 'col-xs-9 form-control';
 
		return (
			<div className="col-lg-6 col-xs-12 column">
				<form className="form-horizontal" onSubmit={this.handleSubmit} role="form">
					<h1>{t('login.title')}</h1>

					<div className={'form-group' + (username.touched && username.error ? ' has-error' : '')}>
						<label className={labelClass} htmlFor="login">
							{t('login.username')}
						</label>
						<div className={'col-xs-' + (username.touched && username.error ? '6' : '8')}>
							<input id="login" type="text" className="form-control" placeholder="" {...username} />
						</div>
						{username.touched && username.error && <div className="col-xs-3 help-block">{username.error}</div>}
					</div>

					<div className={'form-group' + (password.touched && password.error ? ' has-error' : '')}>
						<label htmlFor="password" className={labelClass}>{t('login.password')}</label>
						<div className={'col-xs-' + (password.touched && password.error ? '6' : '8')}>
							<div className="input-group">
								<input id="password" type={this.state.showPassword ? 'text' : 'password'} className="form-control" placeholder="" {...password} />
								<span className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({showPassword: !this.state.showPassword})}>
									<i className={this.state.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} />
								</span>
							</div>
						</div>
						{password.touched && password.error && <div className="col-xs-3 help-block">{password.error}</div>}
					</div>

					<div className="form-group">
						<div className="col-xs-offset-3 col-xs-10">
							<button onClick={handleSubmit(() => {
								login(values).then(() => {});
								this.props.dispatch(idleActions.start())
								return false;
							}
							)} type="submit" className="btn btn-success" disabled={invalid || submitting}>
								<i className={'fa ' + (submitting ? 'fa fa-sign-in' : 'fa-cloud')} />&nbsp;
								{t('login.login')}
						  </button>
							<button type="button" className="btn btn-default" style={{ margin: 10 }} disabled={submitting} onClick={resetForm}>
								Reset
		          </button>
						</div>
					</div>
				</form>
				<p><Link to="/forgot-password">{t('passwordRecovery.forgot_title')}</Link></p>
				{errorAlert}

				{user &&
					<div>
						<p>
							{t('connected', { username: user.name })}
						</p>

						<div>
							<button className="btn btn-danger" onClick={logout}><i className="fa fa-sign-out" />{' '}							
								{t('login.disconnect')}							
							</button>
						</div>
					</div>
				}

			</div>
		);
	}
}

